import { jsx as r } from "react/jsx-runtime";
import { twMerge as t } from "tailwind-merge";
import { BaseButton as e } from "@systemeio/ui";
const d = (o) => /* @__PURE__ */ r(
  e,
  {
    backgroundColor: "bg-gradient-btn",
    color: "text-white",
    hoverBackgroundColor: "",
    hoverColor: "",
    loaderType: "light",
    ...o,
    className: t("rounded-md", o.className)
  }
);
export {
  d as GradientButton
};
